<script setup>
import { ref, isProxy, toRaw } from 'vue'

const props = defineProps(['categoryId', 'modelValue'])
const emit = defineEmits(['update:modelValue'])

const colorsByCat = await $fetch(`/api/colors_by_category_id${props.categoryId ? ('?categoryId=' + props.categoryId) : ''}`)

const value = ref([...props.modelValue.colors]) // Только массив цветов
const selectedIdColors = ref([])
const colorSearhType = ref(props.modelValue.colorSearhType) // Тип поиска цветов

const getCodeByBgColor = (color) => {
    return colorsByCat.find(c => c.bg_color == color).code
}

const getTxtColorByBgColor = (color) => {
    return colorsByCat.find(c => c.bg_color == color).txt_color
}

const getColorNameByBgColor = (color) => {
    return colorsByCat.find(c => c.bg_color == color).color_name
}

const getColorIdByBgColor = (color) => {
    return colorsByCat.find(c => c.bg_color == color).color_id
}

// Метод для сброса выбора цветов
const resetColors = () => {
    value.value = []
    emit('update:modelValue', [])
}

// Привести value к масству ключей
const getKeys = (obj) => {
    if (!obj) {
        return null;
    } else if (isProxy(obj)) {
        selectedIdColors.value = toRaw(obj).map(x => {
            return getColorIdByBgColor(x) ?? 'fail'
        })
        return selectedIdColors.value
    } else {
        return null
    }

}

// Отслеживание внешнего изменения modelValue
watch(() => props.modelValue, (newValue) => {
    value.value = [...newValue.colors]  // Обновляем массив цветов
    colorSearhType.value = newValue.colorSearhType  // Обновляем тип поиска
}, { immediate: true })

// //Отслеживание изменений выбора цвета и типа поиска
// watch([value, colorSearhType], () => {
//     emit('update:modelValue', {
//         colors: value.value, 
//         colorSearhType: colorSearhType.value
//     })
// })

</script>

<template>
    <div class="container-custom-color-picker">
        <span class="label-picker" v-if="$device.isDesktop">Цвет</span>
        <ClientOnly>
            <el-select v-model="value" multiple placeholder="Все цвета" style="width: 245px"
                @change="emit('update:modelValue', { colors: value, colorSearhType: colorSearhType })">
                <el-option v-for="item in colorsByCat" :key="item.color_id" :label="item.color_name"
                    :value="item.bg_color">
                    <div class="flex items-center">
                        <el-tag :color="item.bg_color" style="margin-right: 8px; border: 1px solid var(--el-color-info-light-8);"
                            size="small" />
                        <span>{{ item.color_name }}</span>
                    </div>
                </el-option>
                <template #tag>
                    <el-tag v-for="color in value" :key="color" :color="color"
                        style="border: 1px solid var(--el-color-info-light-8); padding: 0 2px; font-weight: 700;"
                        :style="{ color: getTxtColorByBgColor(color) }">
                        <el-tooltip :content="getColorNameByBgColor(color)" placement="top">
                            {{ getCodeByBgColor(color) }}
                        </el-tooltip>
                    </el-tag>
                </template>
                <template #footer>
                    <el-tag type="info" effect="plain">Условие выбора</el-tag>
                    <br />
                    <el-radio-group v-model="colorSearhType"
                        @change="emit('update:modelValue', { colors: value, colorSearhType: colorSearhType })">
                        <el-tooltip content="Есть любой из выбранных цветов" placement="bottom">
                            <el-radio value="OR">
                                ИЛИ
                            </el-radio>
                        </el-tooltip>
                        <el-tooltip content="Должны быть все выбранные цвета" placement="bottom">
                            <el-radio value="AND">
                                И
                            </el-radio>
                        </el-tooltip>
                    </el-radio-group>
                </template>
            </el-select>
        </ClientOnly>
    </div>
</template>

<style scoped>
.container-custom-color-picker {
    /* background-color: antiquewhite; */
    display: flex;
    align-items: center;
    margin-right: 15px;
}

.label-picker {
    padding-right: 10px;
}

.el-tag {
    border: none;
    aspect-ratio: 1;
}
</style>